module.exports = require("./mni-Beng.js");